import { useRef, useCallback } from 'react';

import { FontAwesomeIcon } from '@hivebrite/design-system/FontAwesomeIcon';

import { IMAGE } from 'hb-react/shared/components/DesignSystem/QuillEditor/constants';
import { useQuillEditorContext } from 'hb-react/shared/components/DesignSystem/QuillEditor/contexts/QuillEditorContext';

import InputFileHidden from '../components/InputFileHidden';
import ToolbarItem from '../components/ToolbarItem';
import getFileInputClickHandler from '../utils/getFileInputClickHandler';

export const ACCEPT_IMAGES = ['image/gif', 'image/png', 'image/jpeg'];

const Image = () => {
  const { onAddFiles, options, setForceEditorFocus } = useQuillEditorContext();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleAddImages = useCallback(
    (files: File[] = []) => {
      onAddFiles?.({
        type: IMAGE,
        files,
      });

      setForceEditorFocus?.(false);
    },
    [onAddFiles, setForceEditorFocus],
  );

  const { toolbar: toolbarOptions, tooltips: tooltipsOptions } = options ?? {};

  return (
    <>
      <ToolbarItem
        onMouseDown={() => setForceEditorFocus?.(true)}
        onClick={getFileInputClickHandler(inputRef)}
        icon={<FontAwesomeIcon iconName="image" height="16px" />}
        disabled={
          typeof toolbarOptions?.images === 'object'
            ? toolbarOptions?.images?.disabled
            : false
        }
        dataTestId="images-action"
        ariaLabel={s__('QuillEditorAccessibility|Add an image')}
        tooltip={tooltipsOptions?.images}
        enableFontAwesomeIcon
      />
      <InputFileHidden
        ref={inputRef}
        dataTestId="images-action-input"
        accept={ACCEPT_IMAGES}
        onChange={handleAddImages}
        multiple={
          typeof toolbarOptions?.images === 'object'
            ? toolbarOptions?.images?.multiple ?? true
            : true
        }
      />
    </>
  );
};

export default Image;
